import { ROUTES } from 'src/router/const'
import { sessionAccessService } from 'src/services/app/session-access.service'
import { AUTH_SCOPE } from 'src/services/consts/auth.const'
import { hasValidGrants } from 'src/services/helpers/session.helper'
import { firstTrimmedQueryString, resolveGrantRoute } from 'src/services/helpers/router.helper'

export function authGuard(to, next) {
  if (to.name === ROUTES.LINK_LOGIN) return next()
  if (to.name === ROUTES.LOGIN) return next()

  const session = sessionAccessService.getAccess(AUTH_SCOPE.MAP)
  const canSilentRelogin = !!sessionAccessService.getReloginCredential(AUTH_SCOPE.MAP)
  const isAuthenticated = !!session?.bearerToken || canSilentRelogin

  if (!isAuthenticated && to.meta.requiresAuth) {
    return next({ name: ROUTES.LOGIN })
  }

  if (hasValidGrants(session?.grants)) {
    const grantId = firstTrimmedQueryString(to.query.grantId)
    const redirect = resolveGrantRoute(to.name, session.grants, grantId)
    if (redirect) return next(redirect)
  }

  next()
}
